// umlaut-check: skip — "zuruecksetzen" ist der technische Name aus
// useGemerkteFilter.jsx, bleibt ASCII.
import React, {useState} from 'react';
import InertiaTable from 'laravel-inertia-react-table';
import {router, usePage} from '@inertiajs/react';
import ImportPositionsModal from './ImportPositionsModal.jsx';
import {Button, useEnhancedTranslation} from "laravel-inertia-backend";
import {PiMicrosoftExcelLogo, PiPencil, PiTrash} from "react-icons/pi";
import Icon from "@mdi/react";
import {mdiClipboardEditOutline} from "@mdi/js";
import {WeclappIcon} from "../../Icons/WeclappIcon.js";
import CurrencyTableCell from "../../Components/CurrencyTableCell.jsx";
import TimestampTableCell from "../../Components/TimestampTableCell.jsx";
import HelpTooltip from "../../Components/HelpTooltip.jsx";
import {AlleFilterZuruecksetzenLink, useGemerkteServerFilter} from "../../Components/Filter/useGemerkteFilter.jsx";

export default function SalesOrders() {
    const {weclappBaseUrl, user_roles, sales_orders, col_definitions, can_order_editor, auth} = usePage().props;
    const [showModal, setShowModal] = useState(false);
    const [selectedDocumentId, setSelectedDocumentId] = useState(null);
    const {t} = useEnhancedTranslation();
    const {weichtAb, zuruecksetzen} = useGemerkteServerFilter("weclapp.sales-orders", {benutzerId: auth?.id});

    const openImportFor = (id) => {
        setSelectedDocumentId(id);
        setShowModal(true);
    }

    const openWeclappOrder = (id) => {
        window.open(`${weclappBaseUrl}app/sales-order/${id}`, '_blank');
    }

    // Zweiter Einstieg in den Auftrags-Editor (PLAN.md 3.1, F2): Aufträge, die
    // direkt in weclapp erfasst wurden, haben keine Bestellung im
    // Ordermanagement und damit auch keinen Knopf an der Bestellzeile.
    const openOrderEditor = (id) => {
        router.visit(`/order-editor/weclapp/${id}`);
    }

    // Die Sichtbarkeit kommt serverseitig berechnet als Flag und nicht über
    // <Can>: Die Inertia-Middleware gibt dem Superadmin pauschal alle
    // Berechtigungsnamen mit, auch die, die er serverseitig nicht hat.
    const orderEditorAction = can_order_editor
        ? [{
            icon: <Icon path={mdiClipboardEditOutline} size={1}/>,
            alt: 'Im Auftrags-Editor öffnen',
            callback: (data) => openOrderEditor(data.id),
        }]
        : [];

    return (<>
            <InertiaTable
                key={'salesorders-table'}
                data={sales_orders}
                title={
                  <span className="d-inline-flex align-items-center gap-2">
                    Verkauf – Aufträge
                    <HelpTooltip placement="right" size={0.95}>
                      <div className="text-start">
                        <strong>Welche Belege werden hier angezeigt?</strong>
                        <div className="mt-1">Verkaufsaufträge aus Weclapp nach festen Regeln:</div>
                        <ul className="mb-0 ps-3 mt-1">
                          <li>Belegtyp: <strong>Verkaufsauftrag</strong> (Sales Order)</li>
                          <li>Status: <strong>ORDER_ENTRY_IN_PROGRESS</strong> – Auftrag wird gerade erfasst</li>
                        </ul>
                        <div className="mt-1">Sortierung: Nummer absteigend.</div>
                      </div>
                    </HelpTooltip>
                  </span>
                }
                actionsDisplay={'column'}
                actions={[
                    { icon: <PiMicrosoftExcelLogo />, alt: t('import from File'), callback: (data) =>openImportFor(data.id) },
                    { icon: <WeclappIcon />, alt:  t('open in Weclapp'), callback: (data) =>openWeclappOrder(data.id) },
                    ...orderEditorAction,
                ]}
                colDefinitions={[...col_definitions]}
                customCellRendererMap={{
                    'netAmount': CurrencyTableCell,
                    'createdDate':TimestampTableCell
            }}
                customToolbarButtons={<AlleFilterZuruecksetzenLink sichtbar={weichtAb} onClick={zuruecksetzen} />}
            />
            <ImportPositionsModal show={showModal} documentId={selectedDocumentId} documentType={'sales_order'} onClose={() => setShowModal(false)}/>
        </>
    );
}
